<div [class.outlook-host]="isOutlookHost">
  @if (isOutlookHost) {
    <swisscom-sign-outlook-file-reader
      (selectedAttachmentsChange)="onSelectedAttachmentsChange($event)"
    ></swisscom-sign-outlook-file-reader>
  }
  @if (isFileSelected() || !isOutlookHost) {
    <div>
      <div class="center-vertical col-xs-12 col-md-12 margin-top-1 margin-left-2">
        <h2 class="h2">{{ 'App.FileReader.SignDocument' | translate }}</h2>
      </div>
      <div class="center-vertical col-xs-12 col-md-8 margin-top-1 margin-left-2">
        <p>{{ 'App.FileReader.Card.Title' | translate }}</p>
      </div>

      @if (!hasError && !uploadSuccess) {
        <div class="row margin-bottom-4 margin-top-4 margin-left-2">
          <div class="col-xs-12 col-md-8">
            <sdx-button-group layout="fullwidth" slot="interaction">
              <sdx-button
                label="{{ 'App.FileReader.SignButton' | translate }}"
                (click)="onSubmit()"
                [loading]="inProgress$ | async"
              >
              </sdx-button>
            </sdx-button-group>
          </div>
        </div>
      }
    </div>
  }
</div>
